import { render, staticRenderFns } from "./FarmUploadValidations.vue?vue&type=template&id=4fd636e1&scoped=true"
import script from "./FarmUploadValidations.vue?vue&type=script&lang=js"
export * from "./FarmUploadValidations.vue?vue&type=script&lang=js"
import style0 from "./FarmUploadValidations.vue?vue&type=style&index=0&id=4fd636e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd636e1",
  null
  
)

export default component.exports